import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FechamentoService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	private httpOptionsFiles = {
		headers: new HttpHeaders({
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E"),
		}),
	}

	constructor(private http: HttpClient) { }

	public findAll(): Observable<{ statusCode: number, message: string[], data: any[] }> {
		return this.http.get<{ statusCode: number, message: string[], data: any[] }>(`${this.url}fechamento`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public findOne(id): Observable<{ statusCode: number, message: string[], data: any }> {
		return this.http.get<{ statusCode: number, message: string[], data: any[] }>(`${this.url}fechamento/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public importarArquivo(formData, idFechamento, idBroker): Observable<any> {
		return this.http
			.post<any>(`${this.url}fechamento-broker-chip/importar/${idFechamento}/${idBroker}`, formData, this.httpOptionsFiles)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public finalizarImportacao(idFechamento): Observable<any> {
		return this.http
			.post<any>(`${this.url}fechamento-broker-chip/final/${idFechamento}`, null, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public excluirDadosImportados(idBroker): Observable<any> {
		return this.http
			.delete<any>(`${this.url}fechamento-broker-chip/broker/${idBroker}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getImportados(idFechamento): Observable<any> {
		return this.http
			.get<any>(`${this.url}fechamento-broker-chip/broker/${idFechamento}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getRelatorioChipsImportados(idFechamento): Observable<any> {
		return this.http
			.get<any>(`${this.url}fechamento-broker-chip/relatorio/${idFechamento}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getFechamentoVeiculoFinal(id_fechamento, id_cliente): Observable<any> {
		return this.http
			.get<any>(`${this.url}fechamento-veiculo-final/${id_cliente}/${id_fechamento}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getFechamentoChipFinal(id_fechamento, id_cliente): Observable<any> {
		return this.http
			.get<any>(`${this.url}fechamento-chip-final/${id_cliente}/${id_fechamento}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	// Baixa o relatório Excel de CDR (Faleflex) do cliente, com o período calculado no backend
	// a partir do fechamento (primeiro ao último dia do mês vigente de tb_fechamento).
	public getRelatorioCdrExcel(id_cliente, id_fechamento): Observable<Blob> {
		return this.http
			.post(`${this.url}cliente/cdr-detalhes-excel`,
				{ cliente_id: id_cliente, id_fechamento: id_fechamento },
				{ headers: this.httpOptions.headers, responseType: 'blob' }
			);
	}

	public getFechamentoFaleFlexFinal(id_fechamento, id_cliente): Observable<any> {
		return this.http
			.get<any>(`${this.url}fechamento-faleflex-final/${id_cliente}/${id_fechamento}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getFechamentoClientes(id_fechamento): Observable<any> {
		return this.http
			.post<any>(`${this.url}fechamento/${id_fechamento}/clientes/`, null, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getIccdsFechamento(id_fechamento, id_cliente): Observable<any> {
		return this.http
			.get<any>(`${this.url}fechamento-chip/iccid/${id_cliente}/${id_fechamento}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public postGerarVenda(id_cliente, id_fechamento): Observable<any> {
		return this.http
			.post<any>(`${this.url}venda/gestao/${id_cliente}/${id_fechamento}`, null, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	// Regra "serviços diferentes do fechamento anterior": data.servicos_diferentes traz o motivo, ou null.
	public getServicosDiferentesFaleflex(id_cliente, id_fechamento): Observable<any> {
		return this.http
			.get<any>(`${this.url}venda/faleflex/servicos-diferentes/${id_cliente}/${id_fechamento}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public postGerarVendaFaleflex(id_cliente, id_fechamento, confirmarServicosDiferentes = false): Observable<any> {
		const confirmacao = confirmarServicosDiferentes ? '?confirmar_servicos_diferentes=1' : '';
		return this.http
			.post<any>(`${this.url}venda/gestao/faleflex/${id_cliente}/${id_fechamento}${confirmacao}`, null, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public postEnviarBoleto(id_cliente, id_fechamento): Observable<any> {
		return this.http
			.post<any>(`${this.url}venda/boleto/${id_cliente}/${id_fechamento}`, null, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public postEnviarBoletoWpp(id_cliente, id_fechamento): Observable<any> {
		return this.http
			.post<any>(`${this.url}venda/boleto/whatsapp/${id_cliente}/${id_fechamento}`, null, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getVendas(id_fechamento, id_cliente, is_sistema = 2): Observable<any> {
		return this.http
			.get<any>(`${this.url}venda/detalhamento/${id_fechamento}/${id_cliente}/${is_sistema}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public postEnviarDados(id_cliente, id_fechamento, cod_tipo): Observable<any> {
		return this.http
			.post<any>(`${this.url}venda/dados/${id_cliente}/${id_fechamento}/${cod_tipo}`, null, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

  public postEnviarBoletoFaleflex(id_cliente, id_fechamento): Observable<any> {
    return this.http
      .post<any>(`${this.url}venda/boleto/faleflex/${id_cliente}/${id_fechamento}`, null, this.httpOptions)
      .pipe(
        (res) => res,
        (error) => error
      );
  }

  public postFechamentoFaleflexItem(id_cliente, id_fechamento, id_servico, payload: { nome: string; quantidade: number; tarifa_venda: number; preco_total: number }): Observable<any> {
    return this.http
      .post<any>(`${this.url}fechamento-faleflex-final/${id_cliente}/${id_fechamento}/${id_servico}`, payload, this.httpOptions)
      .pipe(
        (res) => res,
        (error) => error
      );
  }

  public patchFechamentoFaleflexItem(id_fechamento_faleflex_final, payload: { nome: string; quantidade: number; tarifa_venda: number; preco_total: number }): Observable<any> {
    return this.http
      .patch<any>(`${this.url}fechamento-faleflex-final/${id_fechamento_faleflex_final}`, payload, this.httpOptions)
      .pipe(
        (res) => res,
        (error) => error
      );
  }

  public deleteFechamentoFaleflexItem(id_fechamento_faleflex_final): Observable<any> {
    return this.http
      .delete<any>(`${this.url}fechamento-faleflex-final/${id_fechamento_faleflex_final}`, this.httpOptions)
      .pipe(
        (res) => res,
        (error) => error
      );
  }

  // Tela "Vendas e boletos" do fechamento (id_sistema: 2 = Rastreei, 3 = FaleFlex)
  public getPainelVendas(idFechamento, idSistema): Observable<any> {
    return this.http
      .get<any>(`${this.url}venda/painel/${idFechamento}/${idSistema}`, this.httpOptions)
      .pipe(
        (res) => res,
        (error) => error
      );
  }

  public postAtualizarStatusVenda(idVenda): Observable<any> {
    return this.http
      .post<any>(`${this.url}venda/status/${idVenda}`, null, this.httpOptions)
      .pipe(
        (res) => res,
        (error) => error
      );
  }

  public postReenviarGestaoClick(idVenda): Observable<any> {
    return this.http
      .post<any>(`${this.url}venda/gestao-click/${idVenda}`, null, this.httpOptions)
      .pipe(
        (res) => res,
        (error) => error
      );
  }

  public postAtualizarStatusFechamento(idFechamento, idSistema): Observable<any> {
    return this.http
      .post<any>(`${this.url}venda/status/fechamento/${idFechamento}/${idSistema}`, null, this.httpOptions)
      .pipe(
        (res) => res,
        (error) => error
      );
  }

  public postWhatsappVenda(idVenda): Observable<any> {
    return this.http
      .post<any>(`${this.url}venda/whatsapp/${idVenda}`, null, this.httpOptions)
      .pipe(
        (res) => res,
        (error) => error
      );
  }
}
